<template>
    <div>
        <div class="l-token-select">
            <div class="l-token-year-text" @click="onShowSelect">
                {{ yearValue }}年度<span class="l-token-icon"></span>
            </div>
            <ul v-show="isSelect" class="l-token-year-list">
                <li @click="onSelectItem(item)" v-for="item in yearList" :key="item">
                    {{ item }}年度
                </li>
            </ul>
        </div>
        <img class="l-achievement-top" src="./images/back-top-token.png" width="100%" alt="" />
        <div class=""></div>
        <img class="l-achievement-bottom" src="./images/back-bottom-token.png" width="100%" alt="" />
        <img class="l-achievement-left1" src="./images/back-bottom-left1.png" width="100%" alt="" />
        <img class="l-achievement-left2" src="./images/back-bottom-left2.png" width="100%" alt="" />
        <img class="l-achievement-right1" src="./images/back-bottom-right1.png" width="100%" alt="" />
        <img class="l-achievement-right2" src="./images/back-bottom-right2.png" width="100%" alt="" />
        <div class="l-token-show">
            <p v-show="active">{{ active }}月</p>
        </div>
        <div class="l-token-get">
            <p v-show="prev">{{ prev }}月</p>
        </div>
        <div class="l-token-lock">
            <p v-show="next">{{ next }}月</p>
        </div>
        <img class="l-token-bulibuli" src="./images/pedestal-bulibuli.png" alt="" />
    </div>
</template>
<script>
export default {
    name: "l-achievement-token",
    props: {
        yearValue: {
            type: Number,
            default: new Date().getFullYear(),
        },
        prev: {
            type: Number,
        },
        active: {
            type: Number,
        },
        next: {
            type: Number,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isSelect: false, //是否显示下拉
            yearList: [2022],
        }
    },
    watch: {

    },
    created() {
        this.setYearList(5)
    },

    methods: {
        setYearList(num) {
            for (let i = 1;i <= num;i++) {
                this.yearList.push(this.yearList[0] + i)
            }
        },
        onShowSelect() {
            this.isSelect = !this.isSelect
        },
        onSelectItem(item) {
            if (!this.disabled) {
                return
            }
            this.isSelect = false
            this.$emit("onSelect", item)
        },
    },
}
</script>

<style scoped lang="stylus" >
@import './index.styl';
</style>